import React, { useState, useEffect } from 'react';
import CariSopir from './CariSopir';

function InputHk({ onCancel, onSave, editMode, pasang, title }) {
  const [tglTransaksi, setTglTransaksi] = useState('');
  const [noTransaksi, setNoTransaksi] = useState('');
  const [sopir, setSopir] = useState('');
  const [total, setTotal] = useState('');
  const [byk_cicil, setByk_cicil] = useState('1');
  const [keterangan, setKeterangan] = useState('');
  const [status, setStatus] = useState('');
  const [namaUser, setNamaUser] = useState('');
  const [idUser, setIdUser] = useState('');
  const [nama_ttd1, setNama_ttd1] = useState('');
  const [is_admin, setIs_admin] = useState('');  
  const [canUnvalid, setCanUnvalid] = useState(true);  
  const [showSopirLookup, setShowSopirLookup] = useState(false);
  const schema = localStorage.getItem('schema');

useEffect(() => {
  const today = new Date();
  const formattedToday = today.toISOString().split('T')[0];  

  if (editMode && pasang) {
    const { master } = pasang;
      setTglTransaksi(formatDateForInput(master.TGL_TRANSAKSI));
      setNoTransaksi(master.NO_TRANSAKSI || '');
      setSopir(master.SOPIR || '');
      setTotal(master.TOTAL || '');
      setByk_cicil(master.BYK_CICIL || '1');
      setKeterangan(master.KETERANGAN || '');
      setStatus(master.STATUS || '');
      setNama_ttd1(master.NAMA_TTD1 || '');
  } else if (pasang?.isNew) {
    setNoTransaksi(0);
    setTglTransaksi(formattedToday);
  }

  const storedUser = localStorage.getItem('nama_user') || '';
  const idUser = localStorage.getItem('id_user') || '';  
  const is_admin = localStorage.getItem('is_admin') || '';  
  setNamaUser(storedUser);
  setIdUser(idUser);
  setIs_admin(is_admin);
}, [editMode, pasang]);


const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date)) return '';
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

useEffect(() => {
  const checkUnvalidPermission = async () => {
    try {
      if (!nama_ttd1 || !idUser || !is_admin) return;  

      if (is_admin === 'F') {
        if (idUser === nama_ttd1) {
          const url = `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=unvalid&schema=${schema}&id_user=${idUser}&tipe=1&id_program=PurchaseOrder1`;

          const response = await fetch(url);
          const data = await response.json();

          if (Array.isArray(data) && data.length > 0 && data[0].BUKA === 'F') {
            setCanUnvalid(false);
          } else {
            setCanUnvalid(true);
          }
        } else {
          setCanUnvalid(false);
        }
      } else {
        setCanUnvalid(true);
      }
    } catch (error) {
      console.error('Gagal cek izin unvalid:', error);
      setCanUnvalid(false);
    }
  };

  checkUnvalidPermission();
}, [nama_ttd1, idUser, is_admin]);

const handleValidasi = async () => {
  const id = noTransaksi || '0';

  if (!id || !sopir || !byk_cicil || !total) {
    alert('Mohon lengkapi data penting.');
    return;
  }

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'hk');
    formData.append('id', id);
    formData.append('schema', schema);
    formData.append('id_user', idUser);
    formData.append('tgl_transaksi', tglTransaksi);
    formData.append('sopir', sopir);
    formData.append('total', total);
    formData.append('byk_cicil', byk_cicil);   
    formData.append('keterangan', keterangan);    

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/hk.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status === 'success') {
      alert('HK berhasil divalidasi.');
      onSave();  
    } else {
      alert(`Gagal validasi: ${result.message}`);
    }
  } catch (err) {
    console.error('Validasi error:', err);
    alert('Terjadi kesalahan saat validasi HK.');
  }
};


const handleUnvalid = async () => {
  const id = noTransaksi || '0';

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'hk_unvalid');
    formData.append('id', id);
    formData.append('schema', schema);

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/hk.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status === 'success') {
      setStatus('0');
      alert('HK berhasil unvalid');
      //onSave();  
    } else {
      alert(`Gagal validasi: ${result.message}`);
    }
  } catch (err) {
    console.error('Validasi error:', err);
    alert('Terjadi kesalahan saat validasi HK.');
  }
};


const handleDelete = async () => {
  const id = noTransaksi || '0';

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'hk_hapus');
    formData.append('id', id);
    formData.append('schema', schema);

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/hk.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status === 'success') {
      alert('HK berhasil dihapus');
      onSave();  
    } else {
      alert(`Gagal validasi: ${result.message}`);
    }
  } catch (err) {
    console.error('Validasi error:', err);
    alert('Terjadi kesalahan saat validasi HK.');
  }
};

const handleSelectSopir = (selectedSopir) => {
  setSopir(selectedSopir.SOPIR);     
  setShowSopirLookup(false);
};


  return (
  <div style={{ padding: '20px', backgroundColor: '#ffffff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
    <h2 style={{ marginBottom: '20px', color: '#4A4A4A' }}>{title}</h2>

    {showSopirLookup && (
      <CariSopir
        sopir={sopir}
        onSelect={handleSelectSopir}
        onCancel={() => setShowSopirLookup(false)}
      />
    )}    

    {!showSopirLookup && (
      <>
        <div>
          <label><strong>No Transaksi</strong></label>
          <input
            type="text"
            readOnly
            value={noTransaksi}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', marginBottom: 10, backgroundColor: '#E6E6E6'  }}
          />
        </div>

        <div>
          <label><strong>Tanggal</strong></label>
          <input
            type="date" readOnly
            value={tglTransaksi}
            onChange={(e) => setTglTransaksi(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', marginBottom: 10, backgroundColor: '#E6E6E6' }}
          />
        </div>
        
        <div style={{ marginBottom: '10px' }}>
          <label>Sopir:</label>
          <div style={{ display: 'flex', gap: '5px' }}>
            <input type="text" value={sopir} readOnly style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6'  } } />
            <button
              onClick={() => setShowSopirLookup(true)}
              disabled={status === '9' || status === '5' || status === '6'}
              style={{marginTop: '10px', marginBottom: '10px', padding: '5px 10px', backgroundColor: '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', }}
            >
              Cari
            </button>
          </div>
        </div>   

        <div style={{ marginBottom: '20px' }}>
        <label><strong>Total</strong></label>
        <input
            type="number"
            value={total}
            onChange={(e) => setTotal(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
        />
        </div>

        <div style={{ marginBottom: '20px' }}>
        <label><strong>Jumlah Cicilan:</strong></label>
        <input
            type="number"
            value={byk_cicil}
            min="1" max="10"
            onChange={(e) => {
              const val = parseInt(e.target.value, 10);
              if (val >= 1 && val <= 10) {
                setByk_cicil(val);
              } else if (val > 10) {
                alert('Jumlah cicilan tidak boleh lebih dari 10');
                setByk_cicil(10);
              } else {
                setByk_cicil(1);
              }
            }}
            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
        />
        </div>        


        <div style={{ marginBottom: '20px' }}>
        <label><strong>Keterangan</strong></label>
        <textarea
            value={keterangan}
            onChange={(e) => setKeterangan(e.target.value)}
            rows={3}
            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
        />
        </div>

      
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>                    
          <button
            onClick={onCancel}
            style={{ backgroundColor: 'blue', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px', cursor: 'pointer' }} >
            Batal
          </button>

          <button
            onClick={handleValidasi}
            disabled={status === '9' || status === '5' || status === '6'}
            style={{
              backgroundColor: status === '9' || status === '5' || status === '6' ? '#A5D6A7' : 'green',
              color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px',
              cursor: status === '9' || status === '5' || status === '6' ? 'not-allowed' : 'pointer'
            }}
          >
            Valid
          </button>
        </div>
      </>
    )}

  </div>    
  );
}

export default InputHk;
